import React, { FC, Fragment } from "react";
import { Box, Divider, Stack } from "@mui/material";
import { XsText, StyledRouterA } from "../Text";
import { COLORS } from "constants/layout";
import { useIntl } from "react-intl";
import { DIRECT_PATHS } from "constants/routes";

interface CategoryLinksProps {
  categories: Array<{
    name: string;
    category_name: string;
  }>;
}

const CategoryLinks: FC<CategoryLinksProps> = ({ categories }) => {
  const intl = useIntl();

  return (
    <Stack>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
          alignItems: "baseline",
          maxHeight: "44px", // Limit to approximately 2 lines (adjust if needed based on font size)
          overflow: "hidden",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            right: 0,
            width: "30px",
            height: "16px",
            background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            pointerEvents: "none"
          }
        }}
      >
        {categories.map((category, i) => (
          <Fragment key={i}>
            <StyledRouterA
              to={DIRECT_PATHS.categorySupplier(category.name)}
              className="category-link"
              sx={{
                marginY: 0,
              }}
            >
              {i === 0 && (
                <XsText
                  color={COLORS.green[600]}
                  component="span"
                  sx={{
                    flexShrink: 0,
                    mr: 0.5,
                  }}
                >
                  {intl.formatMessage({ id: "supplier_of" })}
                </XsText>
              )}
              <XsText color={COLORS.green[600]} component="span">
                {category.category_name}
              </XsText>
            </StyledRouterA>
            {i !== categories.length - 1 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  height: 12,
                  alignSelf: "center",
                  margin: "0 4px",
                  borderColor: COLORS.gray[300],
                }}
              />
            )}
          </Fragment>
        ))}
      </Box>
    </Stack>
  );
};

export default CategoryLinks;
